import { render } from "./editFormwork.vue?vue&type=template&id=87d7cc38"
import script from "./editFormwork.vue?vue&type=script&lang=js"
export * from "./editFormwork.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__